<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__apichannelreport}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-select v-model="dataForm.channelId" filterable clearable placeholder="渠道名称">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.returnStatus" filterable clearable placeholder="类型">
            <el-option
                    v-for="item in returnList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTimes"
            value-format="yyyy-MM-dd"
            align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
         -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column prop="currentData" label="日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="channelName" label="渠道名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" header-align="center" align="center">
          <template slot-scope="scope">
	           <span v-if="scope.row.type == 1">进件返</span>
             <span v-if="scope.row.type == 2">撞库返</span>
             <span v-if="scope.row.type == 3">全流程返</span>
        	</template>
        </el-table-column>
        <el-table-column prop="mark" label="是否掩码" header-align="center" align="center">
          <template slot-scope="scope">
	           <span v-if="scope.row.mark == 1">掩码</span>
             <span v-if="scope.row.mark == 0">非掩码</span>
        	</template>
        </el-table-column>
        <el-table-column prop="totalCheckCount" label="撞库总数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="failedCheckCount" label="撞库失败数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="successCheckCount" label="撞库成功数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalPushCount" label="进件总数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="successPushCount" label="进件成功数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="successPushReplyCount" label="推送成功数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="checkSuccessRate" label="撞库成功率" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pushRate" label="进件率" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pushSuccessRate" label="进件成功率" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pushSuccessReplyRate" label="推送成功率" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column> -->
        
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './apichannelreport-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/apichannelreport/page',
        getDataListIsPage: true,
        exportURL: '/sys/apichannelreport/export',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      dateValue: '',
      channels:[],
      returnList:[
      {
            'label':'进件返',
            'value':1,
        },
        {
            'label':'撞库返',
            'value':2,
        },
        {
            'label':'全流程返',
            'value':3,
        }
      ],
      pickerOptions: {
          shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
            
          {
            text: '昨天',
            onClick(picker) {
              console.log(picker)
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '过去七天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log(week,'week')
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;
              
              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              console.log("2312", start, end);
              picker.$emit("pick", [start, end]);
            },

          },
       ]
      },
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getchannelsOptions();
  },
  methods:{
    getTimes() {
        if (this.dateValue != null) {
          this.dataForm.startDate = this.dateValue[0]
          this.dataForm.endDate = this.dateValue[1]
        }else{
          delete this.dataForm.startDate 
        delete this.dataForm.endDate
        }
      },
     //初始化渠道下拉框中的选项
     async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.channels.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
  }
}
</script>
